import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Particle from "../Particle";

function ResetSuccess() {
  const navigate = useNavigate();

  return (
    <Container fluid className="about-section position-relative" style={{ background: "linear-gradient(180deg, #121212 0%, #1a1a1a 100%)" }}>
      <div style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0 }}>
        <Particle />
      </div>
      <Container style={{ paddingTop: "120px", paddingBottom: "120px", position: "relative", zIndex: 5 }}>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <div 
              style={{
                background: "rgba(255, 255, 255, 0.05)",
                borderRadius: "20px",
                padding: "40px",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
                textAlign: "center",
                position: "relative",
              }}
            >
              <div 
                style={{ 
                  fontSize: "70px", 
                  marginBottom: "20px" 
                }}
              >
                ✅
              </div>
              
              <h1 
                style={{
                  fontSize: "2.2em",
                  fontWeight: "700",
                  marginBottom: "20px",
                  background: "linear-gradient(90deg, #805AD5 0%, #D53F8C 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Password Reset Complete
              </h1>
              
              <p style={{ color: "#e0e0e0", fontSize: "1.1em", marginBottom: "30px" }}>
                Your password has been successfully reset. You can now log in to the NuroFit app with your new password.
              </p>
              
              <div className="d-flex flex-column flex-sm-row justify-content-center">
                <Button
                  variant="primary"
                  href="https://apps.apple.com/us/app/nurofit-fitness-app/id6449378126"
                  target="_blank"
                  style={{
                    background: "linear-gradient(90deg, #805AD5 0%, #D53F8C 100%)",
                    border: "none",
                    padding: "10px 25px",
                    borderRadius: "30px",
                    fontSize: "1.1em",
                    marginRight: "15px",
                    marginBottom: "15px",
                    boxShadow: "0 4px 20px rgba(128, 90, 213, 0.3)",
                    position: "relative",
                  }}
                >
                  Open NuroFit App
                </Button>
              </div>
              
              <div className="mt-4">
                <Button
                  variant="link"
                  onClick={() => navigate("/nurofit")}
                  style={{
                    color: "#b0b0b0",
                    textDecoration: "none",
                    position: "relative",
                  }}
                >
                  Return to NuroFit
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default ResetSuccess;